// extracted by mini-css-extract-plugin
export default {"box":"Counter_box__29QLj","value":"Counter_value__4hQHW","wrapper":"Counter_wrapper__Wf450","btn":"Counter_btn__z0qgZ"};